module.exports = __webpack_public_path__ + "browserconfig.xml";


//////////////////
// WEBPACK FOOTER
// ./src/static/browserconfig.xml
// module id = 15
// module chunks = 0